<template>
<div class="menu-item-r">
  <div class="dash-form-container employee-form">
    <div class="v-nav-wrap">
      <el-button
        class="el-button--primary-empty"
        type="primary"
        size="small"
        @click="$router.push('/my-employee-list')"
        >{{ $t('Employee List') }}</el-button
      >
    </div>
    <el-alert
      v-if="this.language!='en'"
      title="请上传您的五官照，让买家更好地辨识您"
      :closable="false"
      type="warning"
      style="padding-left: 8px;font-size: 14px; margin-bottom: 16px;">
    </el-alert>

    <el-form
      :model="employeeInfo"
      :rules="rules"
      label-width="150px"
      label-position="right"
      ref="employeeForm"
    >
      <div class="utils-title">{{ $t('Upload picture4') }}</div>
      <el-form-item label-width="0" prop="headImage" class="picture-form-item">
        <el-upload
           v-loading="imgLoading"
          class="v-uploader"
          :show-file-list="false"
          action
          :http-request="uploadImg"
          accept="image/png, image/jpeg"
          ref="avatarUploader"
        >
          <el-input v-model="employeeInfo.headImage" v-show="false"></el-input>
          <img
            v-if="employeeInfo.headImage"
            :src="employeeInfo.headImage"
            alt
            class="v-header-img"
          />
          <i v-else class="iconfont iconAdd"></i>
        </el-upload>

        <div class="font-size-14">
          <span class="v-up-tip">
            {{ $t('Only support png & jpg, less than 1Mb 350px') }}
          </span>
          <div class="flex-start align-center v-btn-box">
            <span class="theme-color link" @click="triggerUpload">{{
              $t('Upload again')
            }}</span>
            <span
              class="theme-color pointer"
              @click="employeeInfo.headImage = ''"
              >{{ $t('del') }}</span
            >
          </div>
        </div>
      </el-form-item>

      <div class="utils-title">{{ $t('Basic info') }}</div>
      <div class="basic-fields">
        <el-form-item :label="$t('name')" prop="name">
          <el-input v-model="employeeInfo.name" size="small" maxlength="20"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('Email or Mobile')" prop="emailmobile">
          <el-input v-model="employeeInfo.emailmobile" size="small" :disabled="!!$route.params.id" maxlength="30"></el-input>
        </el-form-item> -->
        <el-form-item :label="$t('email')" prop="email">
          <el-input v-model="employeeInfo.email" size="small" :disabled="showEmail" maxlength="300"></el-input>
        </el-form-item>
        <el-form-item :label="$t('Mobile')" prop="mobile">
          <el-input v-model="employeeInfo.mobile" size="small" :disabled="showMobile" maxlength="11"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('Mobile')" prop="mobile">
          <el-input
            v-model="employeeInfo.mobile"
            size="small"
            maxlength="11"
          ></el-input>
        </el-form-item> -->
        <el-form-item :label="$t('Position')" prop="post">
          <el-input v-model="employeeInfo.post" size="small" maxlength="20"></el-input>
        </el-form-item>
        <div class="text-right">
          <el-button
            class="dash-submit"
            :loading="loading"
            @click="validateForm()"
            type="primary"
            >{{ $t('Save') }}</el-button
          >
        </div>
      </div>
    </el-form>
  </div>
</div>
</template>

<script>
import { reg } from '@/utils/function'
import { mapState, mapGetters } from 'vuex'
import { uploadImageByBaseStr, 
updateEmployee 
} from '@/api'
export default {
  name: 'employeeForm',
  data() {
    return {
      imgLoading:false,
      showEmail: false,
      showMobile: false,
      loading: false,
      employeeInfo: {
        id: '',
        userAccountId: '',
        name: '',
        firstName: '',
        lastName: '',
        headImage: '',
        mobile: '',
        post: '',
        email: '',
        emailmobile: ''
      },
      rules: {
        headImage: [
          {
            required: true,
            message: this.$t('Please upload your profile picture'),
            trigger: 'change'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('Please enter your name'),
            trigger: 'blur'
          }
        ]
      },
      maxImgSize: 2 * 1024 * 1024 // 上传图片最大1M
    }
  },
  computed: {
    ...mapState(['employeeDetail']),
    ...mapGetters(['info','language']),
    noAdmin() {
      return (
        !this.info ||
        (this.info && !this.info.exhibitorEmployee) ||
        (this.info &&
          this.info.exhibitorEmployee &&
          !this.info.exhibitorEmployee.admin)
      )
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.noAdmin) {
        vm.$router.replace('/')
      }
    })
  },
  mounted() {
    if (this.noAdmin) {
      return
    }

    // 添加模式
    if (!this.$route.params.id) {
      this.$store.commit('setEmployeeDetail', {})
    } else {
      // 编辑模式，因没有API，此处存到Store
      // 若刷新页面，跳转列表页面
      if (!this.employeeDetail.id) {
        this.$router.push('/my-employee-list')
      } else {
        this.employeeInfo = Object.assign({}, this.employeeDetail)
      }
    }
    if(this.employeeInfo.email) {
      this.showEmail = true
    }
    if(this.employeeInfo.mobile) {
      this.showMobile = true
    }
  },
  methods: {
    uploadImg(req) {
      if (req.file.size > this.maxImgSize) {
        this.$notify.error({
          message: this.$t('Uploaded image can not greater than 1Mb')
        })
        return ''
      }
      const reader = new FileReader()
      reader.readAsDataURL(req.file)
      reader.onload = () => {
        this.imgLoading = true
        let params = {
          bucketName: 'ef-imaster-file',
          objectName: window.PC.FileNameTimeStamp(req.file['name']),
          baseStr: reader.result.split(',')[1],
          bizType: 'IMAGEFILE'
        }
        uploadImageByBaseStr(params).then(res => {
          this.employeeInfo.headImage = res.data.data
          this.imgLoading = false
        })
        .finally(() => {
          this.imgLoading = false
        })
      }
    },

    triggerUpload() {
      this.$refs.avatarUploader.$refs['upload-inner'].$refs['input'].click()
    },

    validateForm() {
      this.$refs['employeeForm'].validate(valid => {
        if (valid) {
          this.submitForm()
        } else {
          return false
        }
      })
    },

    submitForm() {
      // if (reg.phone.exec(this.employeeInfo.emailmobile)) {
      //   this.employeeInfo.mobile = this.employeeInfo.emailmobile
      //   this.employeeInfo.email = ''
      // }
      this.loading = true
      if(this.employeeInfo.mobile==''&& this.employeeInfo.email == '') {
        this.$notify({
          message: this.$t('Please enter your mobile or email'),
          type: 'warning'
        });
        this.loading = false
        return false
      }
      if(this.employeeInfo.mobile==''&&this.employeeInfo.email != '') {
        if (!reg.email.exec(this.employeeInfo.email)) {
          this.$notify({
            message: this.$t('Please enter your correct email address'),
            type: 'warning'
          });
          this.loading = false
          return false
        }
      }

      if(this.employeeInfo.mobile!=''&&this.employeeInfo.email == '') {
        if (!reg.phone.exec(this.employeeInfo.mobile)) {
          this.$notify({
            message: this.$t('Please enter your correct mobile'),
            type: 'warning'
          });
          this.loading = false
          return false
        }
      }

      updateEmployee(this.employeeInfo).then(() => {
        this.$router.push('/my-employee-list')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.dash-form-container
  margin 30px 0
  padding-bottom 60px
  background $color-white

.employee-form
  .picture-form-item
    padding-left 100px

    .el-form-item__content
      display flex
      align-items center
      margin-bottom 20px

  .theme-color
    margin-right 10px

  .link
    cursor pointer

  .v-uploader
    width 100px
    height 100px
    border 1px solid $color-gray-d9
    position relative
    margin-right 32px

    .iconAdd
      position absolute
      width 100px
      height 100px
      top 0
      left 0
      line-height 98px
      margin 0
      color $color-main
      font-size 24px

  .relative
    position relative
    margin-right 32px

  .v-header-img
    position absolute
    width 100%
    height 100%
    top 0
    left 0
    border-radius 50%
    object-fit contain

  .basic-fields
    width 500px
</style>
